import React, { useEffect, useState } from "react";
import "../style/component/profile.css";
import CrownIcon from "../assets/image/crown.svg";
import TutorialIcon from "../assets/image/tutorial.svg";
import PhoneIcon from "../assets/image/phone.svg";
import WalletIcon from "../assets/image/wallets.svg";
import GiftIcon from "../assets/image/gift.svg";
// import EarnCoinsIcon from "../assets/image/earncoins.svg";
import IdeasIcon from "../assets/image/ideas.svg";
import FortuneWheelIcon from "../assets/image/fortune-wheel.svg";
import InsightIcon from "../assets/image/insight.svg";
import HelpIcon from "../assets/image/help.svg";
import LogoutIcon from "../assets/image/logout.svg";
import {
  LevelPreviewModal,
  LogoutModal,
  RatingModal,
} from "../utils/modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RightArrow from "../assets/image/right-arrow-white.svg";
import { useDispatch, useSelector } from "react-redux";
import MenuProfile from "../assets/image/menu-profile-img.png";
import ProfileBadge from "../assets/image/badge-icon-1a.png";
import PremiumBadge from "../assets/image/premium-badge.png";
import { Postdata } from "../utils/api.services";
import HttpService from "../utils/https.services";
import { clearTourStateForUser } from "../utils/tourStorage.js";
import { toast } from "react-toastify";
import { loginClear } from "../redux/actions/auth.action";
import { RakutenListSuccess } from "../redux/actions/rakuten/rakuten.action";
import {
  ProfileImage,
  getUserData,
  UpdatedData,
} from "../redux/selectors/selector";
import StaticProfileImage from "../assets/image/avatar-img.png";
import Joyride from "react-joyride";
import Tour from "./tour";
import { EVENTS, trackEvent } from "../component/mixpanel";
import { AF_EVENTS, trackAFEvent } from "../component/appsflyer";
import { showProfileSideMenu } from "../utils/profileMenuNavigation";

// Inline styles (moved from style/component/profile.css)
const FONT = '"Afacad", sans-serif';
const SECTION_WIDTH = 225;
const SECTION_HEIGHT = 51;
const SECTION_OFFSET_X = 27;
const ACTIVE_WIDTH = SECTION_OFFSET_X + SECTION_WIDTH;

const S = {
  header: {
    background: "transparent",
    padding: `24px 18px 16px ${SECTION_OFFSET_X}px`,
    flexShrink: 0,
  },
  userRow: { gap: 14, alignItems: "flex-start" },
  userImg: { width: 48, height: 48, position: "relative", flexShrink: 0 },
  userImgPhoto: {
    width: "100%",
    height: "100%",
    borderRadius: "100%",
    objectFit: "cover",
  },
  userBadge: {
    width: 18,
    height: 18,
    position: "absolute",
    right: -2,
    bottom: -2,
  },
  userInfo: { flex: 1, minWidth: 0, padding: 0, cursor: "pointer" },
  userName: {
    fontFamily: FONT,
    color: "#fff",
    margin: "0 0 2px",
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "20px",
  },
  userLevel: {
    fontFamily: FONT,
    fontSize: 12,
    lineHeight: "16px",
    color: "rgba(255, 255, 255, 0.9)",
    margin: 0,
  },
  headerChevron: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 20,
    height: 20,
    flexShrink: 0,
    lineHeight: 0,
    marginTop: 0,
    marginLeft: "auto",
    alignSelf: "flex-start",
  },
  chevronImg: { width: 7, height: "auto" },
  plan: { padding: "12px 0 0" },
  planText: {
    fontFamily: FONT,
    fontSize: 12,
    lineHeight: "16px",
    color: "#fff",
    margin: "0 0 8px",
  },
  planStrong: { fontWeight: 700, color: "#fff" },
  upgradeBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "auto",
    height: 30,
    padding: "0 18px",
    borderRadius: 25,
    backgroundColor: "#21232d",
    color: "#fff",
    fontFamily: FONT,
    fontSize: 12,
    fontWeight: 600,
    textAlign: "center",
    textDecoration: "none",
    border: "none",
    lineHeight: 1,
    transition: "background-color 0.2s ease",
  },
  upgradeBtnHover: { backgroundColor: "#1a1c24", color: "#fff" },
  menu: {
    padding: 0,
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    overscrollBehavior: "contain",
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255, 255, 255, 0.25) transparent",
  },
  list: { listStyle: "none", margin: 0, padding: 0 },
  item: {
    margin: 0,
    position: "relative",
    borderBottom: "none",
    height: SECTION_HEIGHT,
    minHeight: SECTION_HEIGHT,
  },
  // replaces li:not(:last-child)::after
  divider: {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: SECTION_WIDTH,
    height: 1,
    background: "rgba(255, 255, 255, 0.18)",
    pointerEvents: "none",
    zIndex: 2,
  },
  // replaces li.active::before
  activePill: {
    position: "absolute",
    left: 0,
    top: 0,
    width: ACTIVE_WIDTH,
    height: SECTION_HEIGHT,
    background: "#fff",
    borderRadius: "0 25.5px 25.5px 0",
    zIndex: 1,
  },
  box: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    overflow: "visible",
    borderRadius: 0,
    width: SECTION_WIDTH,
    height: SECTION_HEIGHT,
    minHeight: SECTION_HEIGHT,
    maxHeight: SECTION_HEIGHT,
    marginLeft: SECTION_OFFSET_X,
    padding: 0,
    background: "transparent",
    gap: 0,
    boxSizing: "border-box",
  },
  boxActive: {
    marginLeft: 0,
    width: ACTIVE_WIDTH,
    paddingLeft: SECTION_OFFSET_X,
    paddingRight: 0,
    zIndex: 2,
  },
  iconWrap: {
    width: 28,
    height: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginRight: 16,
    lineHeight: 0,
    position: "relative",
    zIndex: 1,
  },
  iconImg: {
    width: 24,
    height: 24,
    maxWidth: 24,
    maxHeight: 24,
    objectFit: "contain",
    display: "block",
  },
  info: {
    position: "relative",
    zIndex: 1,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    flex: 1,
    minWidth: 0,
    width: "auto",
  },
  infoTitle: {
    fontFamily: FONT,
    fontSize: 16,
    lineHeight: "20px",
    color: "#fff",
    margin: "0 0 2px",
    fontWeight: 700,
    letterSpacing: "0.01em",
  },
  infoText: {
    fontFamily: FONT,
    fontSize: 12,
    lineHeight: "16px",
    color: "rgba(255, 255, 255, 0.85)",
    margin: 0,
    fontWeight: 400,
    letterSpacing: "0.01em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  infoLink: { textDecoration: "none", color: "inherit", display: "block" },
  itemChevron: {
    width: 7,
    height: "auto",
    flexShrink: 0,
    marginLeft: 10,
    opacity: 0.9,
  },
};

// Menu order, used to hide the divider above/below the active item
// (replaces li:has(+ li.active)::after). null = Log Out.
const MENU_PATHS = [
  "/home/profile/plus",
  "/home/profile/tutorial",
  "/home/profile/contact-us",
  "/home/profile/wallet",
  "/home/profile/shop",
  "/home/quiz",
  "/home/profile/spin-wheel",
  "/home/profile/insights",
  "/home/profile/setting",
  null,
];

const SMALL_SCREEN_QUERY = "(max-width: 479px)";

const ProfileSideMenu = () => {
  const [isModalActive, setModalActive] = useState(false);
  const [isRatingModalActive, setRatingModalActive] = useState(false);
  const [isLevelModalActive, setLevelModalActive] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [currentLevel, setCurrentLevel] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const UserData = useSelector(UpdatedData);
  const getProfile = useSelector(ProfileImage);
  const [firstInsight, setFirstInsight] = useState("");
  const [firstCMS, setFirstCMS] = useState("");

  const [isUpgradeHover, setUpgradeHover] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia(SMALL_SCREEN_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(SMALL_SCREEN_QUERY);
    const onChange = (e) => setIsSmallScreen(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  const TourStyle = {};

  const steps = [
    {
      target: ".empty-step",
    },
    {
      target: ".profile-sidemenu-header",
      content:
        "Check your profile here for badges, achievements, and settings. Manage your account and personalize your experience.",
    },
    {
      target: ".profile-sidemenu li:nth-child(7)", // Quiz
      content:
        "Interactive quizzes designed to test and enhance financial knowledge and trading strategies.",
    },
    {
      target: ".profile-sidemenu li:nth-child(5)", // Shop
      content:
        'Explore the Rally Bulls Store by clicking "Shop" in the navigation menu, browse and view item details, and use Rally Coins to redeem items.',
    },
    {
      target: ".profile-sidemenu li:nth-child(8)", // Spin Wheel
      content:
        "A gamified reward system where users spin to win prizes and incentives.",
    },
  ];
  useEffect(() => {
    FetchInsightsModule();
    FetchCMSModule();
  }, []);

  const FetchInsightsModule = () => {
    Postdata(HttpService()?.inSights)
      .then((result) => {
        if (result?.status && result?.data.length > 0) {
          console.log(101, result);
          setFirstInsight(result?.data[0]?.page_code);
          // setInsights(result?.data);
        } else {
          // toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  const FetchCMSModule = () => {
    Postdata(HttpService()?.cms)
      .then((result) => {
        if (result?.status && result?.data.length > 0) {
          setFirstCMS(result?.data[0]?.page_code);
        } else {
          // toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  const openModal = () => {
    setModalActive(true);
  };

  const closeModal = () => {
    setModalActive(false);
  };

  const openLevelModal = (level) => {
    setCurrentLevel(level);
    setLevelModalActive(true);
  };

  const closeLevelModal = () => {
    setLevelModalActive(false);
  };

  const closeRatingModal = () => {
    setRatingModalActive(false);
  };

  const isActive = (path) => {
    const { pathname } = location;
    return pathname === path || pathname.startsWith(`${path}/`);
  };

  const logouthandler = () => {
    Postdata(HttpService()?.logout)
      .then((result) => {
        if (result.status) {
          toast.success(result?.message);
          clearTourStateForUser(UserData?._id);
          localStorage.removeItem("hasSeenTour");
          localStorage.removeItem("giveProfileChance");
          dispatch(loginClear(result));
          dispatch(RakutenListSuccess([]));
          localStorage.removeItem("ProfileImage");
          navigate("/");
        } else {
          toast.error(result.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  const isPathActive = (path) => (path ? isActive(path) : false);

  // Builds one side-menu row. Styles that used to depend on .active,
  // .subscription-item, ::before, ::after and :has() are computed here.
  const renderMenuItem = ({
    index,
    icon,
    alt,
    iconClassName,
    title,
    subtitle,
    to,
    onLinkClick,
    onInfoClick,
    onBoxClick,
    showChevron = false,
  }) => {
    const active = isPathActive(MENU_PATHS[index]);
    const isSubscription = index === 0;
    const isLast = index === MENU_PATHS.length - 1;
    const nextActive = !isLast && isPathActive(MENU_PATHS[index + 1]);
    const showDivider = !isLast && !active && !nextActive;

    const liClassName = [
      isSubscription ? "subscription-item" : "",
      active ? "active" : "",
    ]
      .filter(Boolean)
      .join(" ");

    const liStyle = {
      ...S.item,
      ...(isSubscription ? { background: "#21232d" } : {}),
      ...(active ? { background: "transparent" } : {}),
    };

    const iconStyle = {
      ...S.iconImg,
      ...(!active && iconClassName === "menu-icon-shop"
        ? { filter: "brightness(0) invert(1)" }
        : {}),
      ...(active
        ? { filter: "brightness(0) saturate(100%) invert(49%)", opacity: 1 }
        : {}),
    };

    const activeText = active ? { color: "#7f7f7f" } : {};

    const text = (
      <>
        <h6 style={{ ...S.infoTitle, ...activeText }}>{title}</h6>
        <p style={{ ...S.infoText, ...activeText }}>{subtitle}</p>
      </>
    );

    return (
      <li className={liClassName || undefined} style={liStyle}>
        {active && <span aria-hidden="true" style={S.activePill} />}
        <div
          className={`profile-menu-box d-flex align-items-center${
            onBoxClick ? " cursor-pointer" : ""
          }`}
          style={{ ...S.box, ...(active ? S.boxActive : {}) }}
          onClick={onBoxClick}
        >
          <div className="icon-wrap" style={S.iconWrap}>
            <img
              src={icon}
              alt={alt}
              className={iconClassName}
              style={iconStyle}
            />
          </div>
          <div
            className="prof-menu-box-info"
            style={S.info}
            onClick={onInfoClick}
          >
            {to ? (
              <Link to={to} onClick={onLinkClick} style={S.infoLink}>
                {text}
              </Link>
            ) : (
              text
            )}
          </div>
          {showChevron && (
            <img
              src={RightArrow}
              alt=""
              className="menu-item-chevron"
              style={S.itemChevron}
            />
          )}
        </div>
        {showDivider && (
          <span
            aria-hidden="true"
            style={{
              ...S.divider,
              ...(isSubscription
                ? { background: "rgba(255, 255, 255, 0.12)" }
                : {}),
            }}
          />
        )}
      </li>
    );
  };

  return (
    <div className="profile-sidemenu-wrap profile-sidemenu-joyride">
      {/* {location.pathname === "/home/profile" && (
        <Tour
          steps={steps}
          isOpen={isTourOpen}
          onRequestClose={() => setIsTourOpen(false)}
        />
      )} */}
      <div className="profile-sidemenu-header" style={S.header}>
        <div
          className="profile-sidemenu-user-row d-flex align-items-start cursor-pointer"
          style={S.userRow}
          onClick={() => navigate("/home/profile")}
        >
          <div className="user-img" style={S.userImg}>
            <img
              src={getProfile ? getProfile : StaticProfileImage}
              alt="MenuProfile"
              style={S.userImgPhoto}
            />
            <div className="icon-wrap" style={S.userBadge}>
              <img src={ProfileBadge} alt="Badge" />
            </div>
          </div>
          <div className="user-info" style={S.userInfo}>
            <h6 style={S.userName}>
              {UserData.username ? UserData.username : "Guest User"}
            </h6>
            <p
              style={S.userLevel}
              onClick={(e) => {
                e.stopPropagation();
                openLevelModal(UserData?.level ? UserData?.level : 0);
              }}
            >
              Level - {UserData?.level ? UserData?.level : 0}
            </p>
          </div>
          <span className="header-nav-chevron" style={S.headerChevron}>
            <img src={RightArrow} alt="" style={S.chevronImg} />
          </span>
        </div>
        <div className="profile-sidemenu-plan" style={S.plan}>
          <p style={S.planText}>
            Current Plan:{" "}
            <strong style={S.planStrong}>
              {UserData?.subscription?.name || "FREE"}
            </strong>
          </p>
          <Link
            to="/home/profile/plus"
            className="sidemenu-upgrade-btn"
            style={{
              ...S.upgradeBtn,
              ...(isUpgradeHover ? S.upgradeBtnHover : {}),
            }}
            onMouseEnter={() => setUpgradeHover(true)}
            onMouseLeave={() => setUpgradeHover(false)}
          >
            Upgrade
          </Link>
        </div>
      </div>
      <div
        className="profile-sidemenu"
        style={{ ...S.menu, ...(isSmallScreen ? { padding: 15 } : {}) }}
      >
        <ul style={S.list}>
          {renderMenuItem({
            index: 0,
            icon: CrownIcon,
            alt: "Subscription",
            title: "Subscription",
            subtitle: "Unlock Premium Benefits",
            to: "/home/profile/plus",
            showChevron: true,
          })}
          {renderMenuItem({
            index: 1,
            icon: TutorialIcon,
            alt: "Tutorials",
            title: "Tutorials",
            subtitle: "Guided Tutorials for Every Feature",
            to: "/home/profile/tutorial",
          })}
          {renderMenuItem({
            index: 2,
            icon: PhoneIcon,
            alt: "Contact Us",
            title: "Contact Us",
            subtitle: "Reach Out to Our Team",
            to: "/home/profile/contact-us",
          })}
          {renderMenuItem({
            index: 3,
            icon: WalletIcon,
            alt: "Wallet",
            title: "Wallet",
            subtitle: "View your Rally Coins Balance",
            to: "/home/profile/wallet",
            onLinkClick: () => showProfileSideMenu(),
          })}
          {renderMenuItem({
            index: 4,
            icon: GiftIcon,
            alt: "Shop",
            iconClassName: "menu-icon-shop",
            title: "Shop",
            subtitle: "Redeem your Rally Coins",
            to: "/home/profile/shop",
            onLinkClick: () => {
              showProfileSideMenu();
              trackAFEvent(AF_EVENTS.MP_SHOP_CLICK, {
                section: "clicked",
                action: "click_shop",
              });

              trackEvent(EVENTS.MP_SHOP_CLICK, {
                section: "clicked",
                action: "click_shop",
              });
            },
          })}
          {/* Earn Coins section hidden for now (route: /home/profile/earn/coin,
              icon: EarnCoinsIcon, "Earn Coins" / "Watch Ads and Earn Rally Coins",
              tracks EVENTS.MP_EARNCOIN_CLICK). If re-enabled, add its path to
              MENU_PATHS in the same position. */}
          {renderMenuItem({
            index: 5,
            icon: IdeasIcon,
            alt: "Quiz",
            title: "Quiz",
            subtitle: "Test your Market Knowledge",
            to: "/home/quiz",
            onLinkClick: () => {
              trackAFEvent(AF_EVENTS.MP_QUIZ, {
                section: "clicked",
                action: "click_quiz",
              });

              trackEvent(EVENTS.MP_QUIZ, {
                section: "clicked",
                action: "click_quiz",
              });
            },
          })}
          {renderMenuItem({
            index: 6,
            icon: FortuneWheelIcon,
            alt: "Spin Wheel",
            title: "Spin Wheel",
            subtitle: "Spin and Win Rally Coins",
            to: "/home/profile/spin-wheel",
            onInfoClick: () => window.location.reload(),
            onLinkClick: () => {
              trackAFEvent(AF_EVENTS.MP_SPINWHEEL_CLICK, {
                section: "clicked",
                action: "click_spinWheel",
              });

              trackEvent(EVENTS.MP_SPINWHEEL_CLICK, {
                section: "clicked",
                action: "click_spinWheel",
              });
            },
          })}
          {renderMenuItem({
            index: 7,
            icon: InsightIcon,
            alt: "Insights",
            title: "Rally Bulls Insights",
            subtitle: "Market Insights and Updates",
            to: `/home/profile/insights/${firstInsight}`,
          })}
          {renderMenuItem({
            index: 8,
            icon: HelpIcon,
            alt: "Help Center",
            title: "Help Center",
            subtitle: "Support, FAQs, and Resources",
            to: `/home/profile/setting/${firstCMS}`,
          })}
          {renderMenuItem({
            index: 9,
            icon: LogoutIcon,
            alt: "Log Out",
            title: "Log Out",
            subtitle: "Sign Out Securely",
            onBoxClick: openModal,
          })}
        </ul>
        <LogoutModal
          isActive={isModalActive}
          onClose={closeModal}
          onClick={logouthandler}
        />
        <RatingModal
          isActive={isRatingModalActive}
          onClose={closeRatingModal}
        />
        <LevelPreviewModal
          isActive={isLevelModalActive}
          onClose={closeLevelModal}
          level={currentLevel}
        />
        {/* <SocialShare
          isActive={isopenShareModal}
          onClose={closeShareModal}
          referalData = {UserData?.referral_code}
          name = {UserData?.username}
        /> */}
      </div>
    </div>
  );
};

export default ProfileSideMenu;
